<template>
    <v-data-table :headers="headers" :items="items" disable-sort :items-per-page="5" class="v-data-table--default v-data-table--none-border-left">
        <template v-for="header in headers.filter((header) => header.hasOwnProperty('formatter'))" v-slot:[`item.${header.value}`]="{ value }"> {{ header.formatter(value) }} </template>
        <template #[`item.price`]="{item, value}">
            <div class="d-flex align-center justify-center">
                <v-chip v-if="isWinner(item)" color="grey-ef" text-color="primary" class="rounded-0 justify-center px-6 py-0 mr-6" style="height:22px; pointer-events: none;">최고가</v-chip>
                <span :class="{ 'font-weight-bold': isWinner(item) }"> {{ value?.format?.() }} </span>
            </div>
        </template>
    </v-data-table>
</template>

<script>
import api from "@/api";
import AuctionDialog from "./auction-dialog.vue";

const headers = [
    { align: "center", text: "응찰자", value: "meta.username", formatter: (value) => value.substring(0, value?.length - 3) + "***" },
    { align: "center", text: "응찰가", value: "price" },
    { align: "center", text: "응찰시간", value: "createdAt", formatter: (value) => value.toDateTime() },
];

export default {
    components: { AuctionDialog },
    props: {
        bids: { type: Array, default: () => [] },
    },
    data: () => ({
        headers,
    }),
    computed: {
        items() {
            return this.bids.sort((a, b) => b?.price - a?.price);
        },
    },
    methods: {
        isWinner({ _id }) {
            return this.items[0]?._id == _id;
        },
    },
};
</script>

<style></style>
